<div class="slider-side-menu" [ngClass]="isShow ? 'opened' : ''">
<!--  <div class="slider-side-menu-header">-->
<!--    <button class="close-btn" (click)="onClose()"><i class="fa fa-times"></i></button>-->
<!--  </div>-->
  <div class="slider-side-menu-body" *ngIf="isShow">
    <ng-content select=".menu"></ng-content>
  </div>

</div>
